import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HOME_SCREEN } from '../../core-utils/routes';
import { useStores } from '../../stores';
import Loader from '../../_components/molecules/Loader';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  TotalFeatures,
  UserAccessConstants,
  formatUserAccessRoutes,
} from '../../core-utils/helper-utils/userAccess';
import { observer } from 'mobx-react';
import { allRoutes } from '../../core-utils/routesHelper';
import { formatUserAccess } from '../../core-utils/formatters/UserManagementPageFormatter';
// import { extractValueFromUserScreenResponse } from '../../core-utils/formatters/UserManagementPageFormatter';
import { jwtDecode } from 'jwt-decode';

//This page is for role based login redirect page in future
const LoginRedirectPage = observer(() => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const loginPageStore = useStores().loginPageStore;
  const userDetailsStore = useStores().userDetailsStore;

  useEffect(() => {
    gotoHomePage();
  }, []);

  // const fetchScreenLists = async () => {
  //   await axios
  //     .get(properties.userManagementBaseUrl + properties.screen)
  //     .then((response) => {
  //       extractValueFromUserScreenResponse(response?.data); //TODO Need to set as TotalFeatures
  //     });
  // };
  // TODO: Add user access needs to be added
  const fetchUserByEmail = async () => {
    const token = JSON.parse(localStorage.getItem('token-storage') as string)
      ?.access_token;
    const decoded: any = jwtDecode(token);
    const isCareNavigator =
      decoded['roles']?.includes('care_navigator') ?? false;
    loginPageStore.setIsAdmin(decoded['roles']?.includes('admin'));
    const userEndpoint = isCareNavigator
      ? properties.careNavigator + properties.getByEmail
      : properties.getUserByEmail;

    await axios
      .get(
        properties.userManagementBaseUrl +
          userEndpoint +
          JSON.parse(localStorage.getItem('token-storage') as string)?.email,
      )
      .then((response) => {
        const user = response.data;
        loginPageStore.addUserResponse(user);
        loginPageStore.addUserData(user.email, user.firstName, user.lastName);
        loginPageStore.setIsCareNavigator(isCareNavigator);
        const userAccessDTOList = response?.data?.employerGroups;
        const userAccessibleRoutes: string[] = [];
        const userAccessibleEmployerGroups: string[] = [];
        if (isCareNavigator) {
          const features = user.features?.filter(
             
            (item: any) => item !== 'CARE_NAVIGATION',
          );
          userAccessibleRoutes.push('CARE_NAVIGATION');
          userAccessibleRoutes.push(...features);
        }

         
        userAccessDTOList?.map((userAccessDTO: any) => {
          userAccessibleRoutes.push(
            ...[
              ...userAccessDTO?.riskManagementScreens,
              ...userAccessDTO?.complianceAssuranceScreens,
              ...userAccessDTO?.careNavigationScreens,
            ],
          );
          userAccessibleEmployerGroups.push(userAccessDTO?.egNid);
        });

        loginPageStore.addUserId(isCareNavigator ? user?.cnId : user?.id);
        loginPageStore.removeUserAccessRoutes();
        if (user?.role?.name === 'super_admin') {
          loginPageStore.addUserAccessRoutes(allRoutes);
          //TODO TotalFetaures need to fetch from API
          loginPageStore.addUserFeatures(TotalFeatures);
          loginPageStore.addEmployerGroups(userAccessibleEmployerGroups);
          loginPageStore.setMemberIdentification(true);
          userDetailsStore.setUserAccess(false);
          userDetailsStore.setUserAccessData({
            riskManagement: true,
            riskManagementGroups: [],
            complianceAssurance: true,
            complianceAssuranceGroups: [],
            careNavigation: true,
            careNavigationGroups: [],
          });
        } else if (
          userAccessibleRoutes !== null &&
          userAccessibleRoutes.length !== 0
        ) {
          const {
            userFeatures,
            userAccessRoutes: formatedUserAccessibleRoutes,
          } = formatUserAccessRoutes(userAccessibleRoutes);
          loginPageStore.addUserAccessRoutes(formatedUserAccessibleRoutes);

          loginPageStore.addUserFeatures(userFeatures);
          loginPageStore.addEmployerGroups(userAccessibleEmployerGroups);
          loginPageStore.setMemberIdentification(
            userFeatures?.includes(UserAccessConstants.MEMBER_IDENTIFICATION),
          );
          userDetailsStore.setUserAccessData(formatUserAccess(user));
          userDetailsStore.setUserAccess(true);
        }
      });
  };

  const gotoHomePage = () => {
    // fetchScreenLists();
    Promise.allSettled([fetchUserByEmail()]).then(() => {
      navigate(HOME_SCREEN);
      setLoading(false);
    });
  };

  const [loader] = useState<any>(<Loader />);

  return <>{loading ? loader : <></>}</>;
});

export default LoginRedirectPage;
